import { endpoints } from './endpoints';
import { http } from './http';
import { IBasePagingRes, IBaseRes, ID, IFindReq } from '@/types';

export class BaseService<T> {
  url: string;

  constructor(url: string = endpoints.materialCategories) {
    this.url = url;
  }

  public async get<Req, Res>(params: IFindReq & Req) {
    const { data } = await http.get<Res>(this.url, { params });
    return data;
  }

  public async find<Req>(params?: IFindReq & Req) {
    const { data } = await http.get<IBasePagingRes<T>>(this.url, { params });
    return data;
  }

  public async findOne<Res = T>(id?: ID) {
    const { data } = await http.get<IBaseRes<Res>>(this.url + '/' + id);
    return data;
  }

  public async postNew<Req, Res = T>(body: Req) {
    const { data } = await http.post<Res>(this.url, body);
    return data;
  }

  public async post<Req, Res = T>(body: Req) {
    const { data } = await http.post<IBaseRes<Res>>(this.url, body);
    return data;
  }

  public async put<Req, Res = T>(id: ID, body: Req) {
    const { data } = await http.put<IBaseRes<Res>>(this.url + '/' + id, body);
    return data;
  }

  public async postForm<Req, Res = T>(body: Req) {
    const { data } = await http.postForm<IBaseRes<Res>>(this.url, body);
    return data;
  }

  public async update<Req, Res>(id: ID, data: Req) {
    return http.put<Res>(this.url + '/' + id, data);
  }

  public async putForm<Res = T>(id: ID, data: FormData) {
    return http.putForm<IBaseRes<Res>>(this.url + '/' + id, data);
  }

  public async delete<Res>(id: ID) {
    return http.delete<Res>(this.url + '/' + id);
  }
}
